import { OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import * as actions from "../../../store/actions/index";
import * as selectors from "../../../store/reducers/index";
import { CUSTOMER_CARER_ROLE, CARER_ROLE, CUSTOMER_FAMILY_ROLE, FAMILY_ROLE } from "@careapp/core";
import { MatDialogRef } from "@angular/material";
var AddToTeamDialog = /** @class */ (function () {
    function AddToTeamDialog(store, dialogRef, customerId) {
        this.store = store;
        this.dialogRef = dialogRef;
        this.customerId = customerId;
    }
    AddToTeamDialog.prototype.ngOnInit = function () {
        this.staff$ = this.store.select(selectors.getSearchResults(selectors.STAFF));
        this.store.dispatch(actions.Staff.RequestAllAction);
        this.searchStaff("");
    };
    AddToTeamDialog.prototype.addToTeam = function (data) {
        console.log(data);
        if (data.member) {
            this.addMember(data);
        }
        else {
            this.invite(data);
        }
        this.dialogRef.close();
    };
    AddToTeamDialog.prototype.searchStaff = function (search) {
        var or = [];
        if (!search.trim()) {
            return;
        }
        search
            .split(" ")
            .filter(function (term) { return !!term || !!term.trim(); })
            .forEach(function (term) {
            or = or.concat(["firstName", "lastName", "email"].map(function (key) {
                var _a;
                return (_a = {},
                    _a[key] = { ilike: term.trim() + "%" },
                    _a);
            }));
        });
        this.store.dispatch(actions.Staff.RequestSearchAction({ where: { or: or } }));
    };
    AddToTeamDialog.prototype.cancelPressed = function () {
        this.dialogRef.close();
    };
    AddToTeamDialog.prototype.addMember = function (data) {
        this.store.dispatch(actions.CustomerTeam.RequestCreateAction({
            staff: data.member,
            role: data.role
        }));
    };
    AddToTeamDialog.prototype.invite = function (data) {
        var permissions = [
            {
                modelId: this.customerId,
                modelName: "Customer",
                role: data.role
            }
        ];
        var role;
        switch (data.role) {
            case CUSTOMER_CARER_ROLE:
                role = CARER_ROLE;
                break;
            case CUSTOMER_FAMILY_ROLE:
                role = FAMILY_ROLE;
                break;
            default:
                return;
        }
        this.store.dispatch(new actions.RequestInvitationSendAction({
            email: data.email,
            role: role,
            permissions: permissions
        }));
    };
    return AddToTeamDialog;
}());
export { AddToTeamDialog };
